import { ax } from '../utils/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'

export const apiATPSectionPDFProcess = ({
  id, // VMP Site Map ID
  serialId,
  emailAddress,
}: {
  id: number,
  serialId: number,
  emailAddress: string
}) => {
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/pdf/atp/${id}`,
    // responseType: 'blob',
    params: {
      reqSid: serialId,
      reqRole: RoleId.ProjectManager,
      emailAddress: emailAddress
    }, 
    headers: {
      Accept: 'application/json',
    }
  }
  return ax(options)
}